import React from 'react'
import PropTypes from 'prop-types'
import { FlexContainer } from '@edulastic/common'

import styled from 'styled-components'
import { StyledButton } from '../styled'
import { leftControls } from '../constants/controls'

const LeftButtons = ({ onChangeTool, activeMode }) => {
  const onClickHandler = (mode) => () => {
    onChangeTool(mode)
  }

  return (
    <FlexContainer>
      {leftControls.map((btn, idx) => (
        <StyledButton
          key={btn.mode}
          id={btn.mode}
          pos={btn.pos}
          aria-label={`${btn.label} ${
            activeMode === btn.mode || (!activeMode && idx === 0)
              ? ',selected'
              : ''
          }`}
          onClick={onClickHandler(btn.mode)}
          selected={activeMode === btn.mode || (!activeMode && idx === 0)}
          aria-selected={activeMode === btn.mode || (!activeMode && idx === 0)}
        >
          {(activeMode === btn.mode || (!activeMode && idx === 0)) && (
            <StyledHiddenAccessibilitySpan>
              Selected {btn.label}
            </StyledHiddenAccessibilitySpan>
          )}
          <span aria-hidden="true" />
        </StyledButton>
      ))}
    </FlexContainer>
  )
}

LeftButtons.propTypes = {
  onChangeTool: PropTypes.func,
  activeMode: PropTypes.string,
}

LeftButtons.defaultProps = {
  onChangeTool: () => null,
  activeMode: '',
}

export default LeftButtons

export const StyledHiddenAccessibilitySpan = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  left: -9999px;
`
